export const COVERAGES_ASSIGN_CONFIG = {
    stationName: {
        key: "station_name",
        label: "Planta",
    },
    coverageName: {
        key: "route_name",
        label: "Cobertura",
    },
    unitName: {
        key: "unit_number",
        label: "Unidad",
    },
    statusName: {
        key: "statusName",
        label: "Estatus",
    }
};

export const COVERAGES_ASSIGN_PHRASE = {
    page: {
        table: {
            title: "Catalogo de Asignación Coberturas",
            actions: {
                edit: 'Editar',
                delete: 'Eliminar'
            }
        }
    },
    modal: {
        titles: {
            edit: "Modificar Asignación de Cobertura",
            add: "Agregar Nueva Asignación",
            delete: "¿Estas seguro de eliminar esta Asignación?",
        },
        actions: {
            cancel: "Cancelar",
            add: "Agregar",
            delete: "Eliminar",
            save: "Guardar",
        },
    },
    search: {
        messages: {
            noStations: "No se ha seleccionado alguna planta.",
        },
    },
};
